import { useFormikContext, getIn, Field } from "formik";
import { getAvailableVariables } from "./utils";
import { Switch } from "src/sudokit/components/Switch";

function CardOutputBlockEditor({ block, optionsPath }) {
  const { values, setFieldValue } = useFormikContext();
  const blockOptions = getIn(values, optionsPath);
  const availableVariables = getAvailableVariables(values.blocks, block.id);

  return (
    <div className="flex flex-col gap-2">
      <div>
        Title: <Field name={`${optionsPath}.title`} />
      </div>
      <div>
        Description:{" "}
        <Field
          name={`${optionsPath}.descriptionVariable`}
          component="select"
        >
          {availableVariables.map((variable) => (
            <option
              key={variable}
              value={variable}
            >
              {variable}
            </option>
          ))}
        </Field>
      </div>
      <div>
        <Field name={`${optionsPath}.disableChiclets`}>
          {({ field }) => (
            <Switch
              label="Disable Chiclets"
              checked={field.value || false}
              onCheckedChange={(checked) => {
                setFieldValue(optionsPath, { ...blockOptions, disableChiclets: checked });
              }}
            />
          )}
        </Field>
      </div>
      <div>
        <Field name={`${optionsPath}.enableOptionTitles`}>
          {({ field }) => (
            <Switch
              label="Enable Option Titles"
              checked={field.value || false}
              onCheckedChange={(checked) => {
                setFieldValue(optionsPath, { ...blockOptions, enableOptionTitles: checked });
              }}
            />
          )}
        </Field>
      </div>
      {blockOptions?.enableOptionTitles && (
        <div>
          Option Title Variable:{" "}
          <Field
            name={`${optionsPath}.optionTitleVariable`}
            component="select"
          >
            <option value="">Select a variable</option>
            {availableVariables.map((variable) => (
              <option
                key={variable}
                value={variable}
              >
                {variable}
              </option>
            ))}
          </Field>
        </div>
      )}
    </div>
  );
}

export default CardOutputBlockEditor;
